
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiListAltCheckGoogle as ObiListAltCheckGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-list-alt-check-google.js';
 
 
 

 
 export const ObiListAltCheckGoogle = createComponent({
   react: React,
   tagName: 'obi-list-alt-check-google',
   elementClass: ObiListAltCheckGoogleElement,
   events: {
     
   }
  });
 
 